import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router keeps the previous scroll offset on navigation, which on mobile
// drops users into the middle (or footer) of the next page. Reset on path change.
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search]);
  return null;
}
